import { render, staticRenderFns } from "./CardFranquia.vue?vue&type=template&id=1eca912f&scoped=true"
import script from "./CardFranquia.vue?vue&type=script&lang=js"
export * from "./CardFranquia.vue?vue&type=script&lang=js"
import style0 from "./CardFranquia.vue?vue&type=style&index=0&id=1eca912f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eca912f",
  null
  
)

export default component.exports